var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.getActiveClass, 'nav-item']},[_c('router-link',_vm._b({},'router-link',_vm.linkProps(_vm.to),false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }